import { SelectItem } from '@panwds/react-ui';
import { Select, Input, FormLayout } from '@panwds/react-form';
import { FormProvider, UseFormReturn } from 'react-hook-form';
import { useTranslate } from "../../../customHooks";
import { SubscriptionAccountIdField, SubscriptionBillingCodeField } from './FormFields';
import { SubscriptionSubmitButton } from './ButtonComponents';
import {
    SUBSCRIPTION_FIELDS,
    SUBSCRIPTION_I18N_KEYS,
    SUBSCRIPTION_METRICS
} from '../constants';

interface CloudNgfwLinkAccountFormProps {
    formMethods: UseFormReturn<any>;
    accountId: string;
    email?: string;
    tenantChoices: SelectItem[] | undefined;
    subscriptionsLoading: boolean;
    billingAssociationCode?: string;
    isValid: boolean;
    hasError?: boolean;
    onSubmit: (params: any) => void;
}

/**
 * Cloud NGFW specific link account form
 * Displays account ID, email, tenant selection, and optional billing code fields
 */
export const CloudNgfwLinkAccountForm = ({
    formMethods,
    accountId,
    email,
    tenantChoices,
    subscriptionsLoading,
    billingAssociationCode,
    isValid,
    hasError,
    onSubmit
}: CloudNgfwLinkAccountFormProps) => {
    const translate = useTranslate();

    return (
        <FormProvider {...formMethods}>
            <form onSubmit={formMethods.handleSubmit(onSubmit)}>
                <FormLayout>
                        <SubscriptionAccountIdField
                            value={accountId}
                            dataMetrics={SUBSCRIPTION_METRICS.LINK_ACCOUNT_ACCOUNT_ID}
                        />

                        {email && hasError && (
                            <Input
                                name={SUBSCRIPTION_FIELDS.USER_NAME}
                                type="email"
                                label={translate(SUBSCRIPTION_I18N_KEYS.EMAIL)}
                                dataMetrics={SUBSCRIPTION_METRICS.LINK_ACCOUNT_EMAIL}
                                value={email}
                                readOnly
                                placeholder=""
                            />
                        )}

                        {(tenantChoices?.length && tenantChoices?.length > 1) && (
                            <Select
                                items={tenantChoices}
                                label={translate(SUBSCRIPTION_I18N_KEYS.TENANT_ID)}
                                name={SUBSCRIPTION_FIELDS.TENANT_ID}
                                dataMetrics={SUBSCRIPTION_METRICS.LINK_ACCOUNT_TENANT}
                                dataTestId={SUBSCRIPTION_METRICS.LINK_ACCOUNT_TENANT}
                                requiredAsterisk
                                simpleFormat
                                isLoading={subscriptionsLoading}
                                placeholder=""
                            />
                        )}

                        {billingAssociationCode && (
                            <SubscriptionBillingCodeField
                                value={billingAssociationCode}
                                dataMetrics={SUBSCRIPTION_METRICS.LINK_ACCOUNT_ASSOCIATION_CODE}
                                readOnly={!hasError}
                            />
                        )}

                        <SubscriptionSubmitButton
                            dataMetrics={SUBSCRIPTION_METRICS.LINK_ACCOUNT_CONTINUE}
                            disabled={!isValid}
                        >
                            {translate(SUBSCRIPTION_I18N_KEYS.CONTINUE)}
                        </SubscriptionSubmitButton>
                </FormLayout>
            </form>
        </FormProvider>
    );
};
